const MONTH_ABBR = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

const parseMonth = (month) => {
    const [year, monthIndex] = month.split("-").map(Number);
    return { year, monthIndex: monthIndex - 1 };
};

const pad = (value) => String(value).padStart(2, "0");

// Last N complete months (default 12), excluding the current month (YYYY-MM strings)
export const getDefaultMonthRange = (months = 12) => {
    const now = new Date();
    const end = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const start = new Date(now.getFullYear(), now.getMonth() - months, 1);
    return {
        startMonth: `${start.getFullYear()}-${pad(start.getMonth() + 1)}`,
        endMonth: `${end.getFullYear()}-${pad(end.getMonth() + 1)}`,
    };
};

// Chronological comparator for Mon-YY labels (e.g., "Mar-24")
export const compareMonthLabels = (a, b) => monthLabelKey(a) - monthLabelKey(b);

const monthLabelKey = (label) => {
    const [mon, yy] = label.split("-");
    return Number(yy) * 12 + MONTH_ABBR.indexOf(mon);
};

// Earliest Mon-YY label among the given values, as YYYY-MM (null when none).
// Used to limit the range picker to months that actually have data.
export const earliestYearMonth = (labels) => {
    const valid = labels.filter((l) => /^[A-Z][a-z]{2}-\d{2}$/.test(l));
    if (!valid.length) return null;
    const earliest = valid.reduce((a, b) => (compareMonthLabels(a, b) <= 0 ? a : b));
    const [mon, yy] = earliest.split("-");
    return `20${yy}-${pad(MONTH_ABBR.indexOf(mon) + 1)}`;
};

// Inclusive list of Mon-YY labels matching Oracle TO_CHAR(date, 'Mon-YY')
export const getMonthLabelsInRange = (startMonth, endMonth) => {
    const start = parseMonth(startMonth);
    const end = parseMonth(endMonth);
    const labels = [];
    const current = new Date(start.year, start.monthIndex, 1);
    const last = new Date(end.year, end.monthIndex, 1);

    while (current <= last) {
        const year = current.getFullYear().toString().slice(-2);
        labels.push(`${MONTH_ABBR[current.getMonth()]}-${year}`);
        current.setMonth(current.getMonth() + 1);
    }

    return labels;
};
